module.exports = __webpack_public_path__ + "img/angle-right.c364e702.svg";